import {
  useItemObserverResourceReaderDev,
  useRealtimeBufferResourceReaderDev,
  useSdkRowPrefetchResourceReaderDev,
} from './resource-usage-reader-hooks.impl.js';

interface CurrentRef<T> {
  readonly current: T;
}

export interface ItemObserverResourceEntry {
  readonly el: unknown | null;
  readonly unsubInstall: (() => void) | null;
}

type UseItemObserverReader = (
  cache: CurrentRef<ReadonlyMap<string, ItemObserverResourceEntry>>,
) => void;
type UseRealtimeBufferReader = (
  rowBuffer: CurrentRef<ReadonlyMap<string, readonly unknown[]>>,
  staleRows: CurrentRef<ReadonlySet<string>>,
  preSnapshotBuffer: CurrentRef<readonly unknown[]>,
) => void;
type UseSdkRowPrefetchReader = (prefetch: CurrentRef<unknown | undefined>) => void;

const noopItemObserverReader: UseItemObserverReader = () => {};
const noopRealtimeBufferReader: UseRealtimeBufferReader = () => {};
const noopSdkRowPrefetchReader: UseSdkRowPrefetchReader = () => {};

export const useItemObserverResourceReader: UseItemObserverReader =
  process.env.NODE_ENV === 'production' ? noopItemObserverReader : useItemObserverResourceReaderDev;
export const useRealtimeBufferResourceReader: UseRealtimeBufferReader =
  process.env.NODE_ENV === 'production'
    ? noopRealtimeBufferReader
    : useRealtimeBufferResourceReaderDev;
export const useSdkRowPrefetchResourceReader: UseSdkRowPrefetchReader =
  process.env.NODE_ENV === 'production'
    ? noopSdkRowPrefetchReader
    : useSdkRowPrefetchResourceReaderDev;
